document.addEventListener('DOMContentLoaded', () => {
  const copyButtons = document.querySelectorAll('.chill-copy-link');

  copyButtons.forEach((button) => {
    button.addEventListener('click', async () => {
      const url = button.dataset.copyUrl;

      if (!url) return;

      const showCopiedState = () => {
        button.classList.add('is-copied');

        window.setTimeout(() => {
          button.classList.remove('is-copied');
        }, 1600);
      };

      try {
        if (
          navigator.clipboard &&
          typeof navigator.clipboard.writeText === 'function'
        ) {
          await navigator.clipboard.writeText(url);
          showCopiedState();
          return;
        }

        throw new Error('Clipboard API unavailable');
      } catch (error) {
        const textarea = document.createElement('textarea');

        textarea.value = url;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.top = '-9999px';
        textarea.style.left = '-9999px';
        textarea.style.opacity = '0';

        document.body.appendChild(textarea);

        textarea.focus();
        textarea.select();

        try {
          document.execCommand('copy');
          showCopiedState();
        } catch (fallbackError) {
          console.error('Unable to copy article URL.', fallbackError);
        }

        textarea.remove();
      }
    });
  });


  document.querySelectorAll('.chill-related').forEach((section) => {
    const track = section.querySelector('[data-related-track]');
    const dotsContainer = section.querySelector('[data-related-dots]');

    if (!track || !dotsContainer) return;

    const cards = Array.from(
      track.querySelectorAll('.chill-related-card')
    );

    if (!cards.length) {
      dotsContainer.hidden = true;
      return;
    }

    let resizeTimer = null;
    let scrollTimer = null;
    let pageTargets = [];


    const getCardsPerView = () => {
      if (window.matchMedia('(max-width: 749px)').matches) {
        return 1;
      }

      if (window.matchMedia('(max-width: 989px)').matches) {
        return 2;
      }

      return 3;
    };


    const getTargetLeft = (card) => {
      return Math.max(
        0,
        card.offsetLeft - track.offsetLeft
      );
    };


    const calculatePageTargets = () => {
      const cardsPerView = getCardsPerView();

      pageTargets = [];

      for (
        let index = 0;
        index < cards.length;
        index += cardsPerView
      ) {
        pageTargets.push({
          cardIndex: index,
          left: getTargetLeft(cards[index])
        });
      }

      const maxScroll = Math.max(
        0,
        track.scrollWidth - track.clientWidth
      );

      pageTargets = pageTargets.map((target) => ({
        cardIndex: target.cardIndex,
        left: Math.min(target.left, maxScroll)
      }));

      const uniqueTargets = [];

      pageTargets.forEach((target) => {
        const alreadyExists = uniqueTargets.some((item) => {
          return Math.abs(item.left - target.left) < 2;
        });

        if (!alreadyExists) {
          uniqueTargets.push(target);
        }
      });

      pageTargets = uniqueTargets;
    };


    const getClosestPageIndex = () => {
      if (!pageTargets.length) return 0;

      let closestIndex = 0;
      let smallestDistance = Infinity;

      pageTargets.forEach((target, index) => {
        const distance = Math.abs(
          track.scrollLeft - target.left
        );

        if (distance < smallestDistance) {
          smallestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    };


    const setActiveDot = () => {
      const dots = Array.from(
        dotsContainer.querySelectorAll('.chill-related__dot')
      );

      if (!dots.length) return;

      const activeIndex = getClosestPageIndex();

      dots.forEach((dot, index) => {
        const isActive = index === activeIndex;

        dot.classList.toggle('is-active', isActive);

        dot.setAttribute(
          'aria-current',
          isActive ? 'true' : 'false'
        );
      });
    };


    const buildDots = () => {
      calculatePageTargets();

      dotsContainer.innerHTML = '';

      if (pageTargets.length <= 1) {
        dotsContainer.hidden = true;
        return;
      }

      dotsContainer.hidden = false;

      pageTargets.forEach((target, index) => {
        const dot = document.createElement('button');

        dot.type = 'button';
        dot.className = 'chill-related__dot';

        dot.setAttribute(
          'aria-label',
          `Go to related articles page ${index + 1}`
        );

        dot.setAttribute(
          'aria-current',
          index === 0 ? 'true' : 'false'
        );

        if (index === 0) {
          dot.classList.add('is-active');
        }

        dot.addEventListener('click', () => {
          track.scrollTo({
            left: target.left,
            behavior: window.matchMedia(
              '(prefers-reduced-motion: reduce)'
            ).matches
              ? 'auto'
              : 'smooth'
          });
        });

        dotsContainer.appendChild(dot);
      });

      setActiveDot();
    };


    track.addEventListener(
      'scroll',
      () => {
        window.clearTimeout(scrollTimer);

        scrollTimer = window.setTimeout(() => {
          setActiveDot();
        }, 70);
      },
      {
        passive: true
      }
    );


    window.addEventListener('resize', () => {
      window.clearTimeout(resizeTimer);

      resizeTimer = window.setTimeout(() => {
        buildDots();
      }, 180);
    });


    buildDots();
  });
});